<template>
  <div v-editable="blok" class="blok contained two-col" v-if="recipes.length>0">
    <div class="blok-container px-2" :key="index" v-for="(promotion,index) in blok.items">
      <component
        @selectPromotion="onPromotionSelected"
        @addToBasket="onAddToBasket"
        :customiseLabel="blok.customize_text"
        :recipes="recipes"
        :blok="promotion"
        :is="promotion.component"
        :customiseLink="(blok.customize_link ? blok.customize_link.cached_url : null) | formatSbInternalLink"
        refs="recipeRenderer"
      ></component>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import PromotionItem from './PromotionItem.vue';

export default {
    name: 'promotion-list',
    props: {
        recipes: Array,
        blok:  Object,
        selectable: Boolean
    },
    components: {
        'promotion': PromotionItem
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences
        }),
        styles: function() {
            const b = this.$props.blok;
            return ['recipe-grid-simple', b.styles, b.item_size];
        }
    },
    methods: {
        onPromotionSelected: function(promotion) {
            
        },
        onAddToBasket: function(recipe) {
            this.$emit('addToBasket',{recipe,index:-1});
        },
        onRemoveFromBasket: function(recipe,index) {
            this.$emit('removeFromBasket',{recipe,index});
        }
    }
}
</script>